import * as React from 'react';
const AccordionContext = React.createContext({ accordionId: 'accordion', onToggle: () => { }, openedItems: [], values: [] });
export default AccordionContext;
//# sourceMappingURL=AccordionContext.js.map